module.exports = __webpack_public_path__ + "static/media/12 Belt Grip.8defde87.jpg";